import React from 'react';
import { useNavigate } from 'react-router-dom';
import DomeGallery from './DomeGallery';
import './GalleryPage.css';

const GalleryPage = () => {
  const navigate = useNavigate();

  return (
    <section id="gallery" className="gallery">
      <div className="container">
        <h2 className="section-title">Gallery</h2>
        <div className="gallery-3d-container">
          <DomeGallery />
        </div>
        {
          /*
        <div className="gallery-buttons">
          <button 
            className="btn coordinators-btn" 
            onClick={() => navigate('/coordinators')}
          >
            View Coordinators
          </button>
          
        </div>
        */}
      </div>
    </section>
  );
};

export default GalleryPage;
